import Api from './Api'

class ExternalInstructionsService {
  /**
   * Get all orders with unprocessed external instructions
   * @returns {Promise} API response with list of orders
   */
  static async getUnprocessedInstructions() {
    return Api().get('/instructions/unprocessed')
  }

  /**
   * Get external instructions for a specific order
   * @param {string} orderId - The order ID
   * @returns {Promise} API response with order instructions
   */
  static async getOrderInstructions(orderId) {
    return Api().get(`/instructions/${orderId}`)
  }

  /**
   * Update external instructions for an order
   * @param {string} orderId - The order ID
   * @param {Object} instructionsData - The instructions data to update
   * @returns {Promise} API response
   */
  static async updateInstructions(orderId, instructionsData) {
    return Api().put(`/instructions/${orderId}`, instructionsData)
  }

  /**
   * Mark external instructions as processed
   * @param {string} orderId - The order ID
   * @returns {Promise} API response
   */
  static async markAsProcessed(orderId) {
    return Api().post(`/instructions/${orderId}/process`)
  }

  /**
   * Reopen external instructions (mark as unprocessed)
   * @param {string} orderId - The order ID
   * @returns {Promise} API response
   */
  static async reopenInstructions(orderId) {
    return Api().post(`/instructions/${orderId}/reopen`)
  }

  /**
   * Delete external instructions from an order
   * @param {string} orderId - The order ID
   * @returns {Promise} API response
   */
  static async deleteInstructions(orderId) {
    return Api().delete(`/instructions/${orderId}`)
  }
}

export default ExternalInstructionsService